<template>
  <step-display :current-step="1">
    <choose-account v-if="get_adwords_ids" :ids="get_adwords_ids"/>
  </step-display>
</template>

<script>
import { mapGetters } from "vuex";
import StepDisplay from "@/components/global/StepDisplay";
import ChooseAccount from "@/components/steps/ChooseAdwordsAccount";
import {objectLength} from "@/utils";

export default {
  name: "ChooseAdwordsAccount",
  components: {
    StepDisplay,
    ChooseAccount,
  },
  mounted() {
    if ( ! objectLength( this.get_adwords_ids)  ) {
      this.$router.push({ name: 'Connect Google',params: { support: true } });
    }
  },
  computed: {
    ...mapGetters(['get_adwords_ids'])
  },
}
</script>